import type { Card } from '@shared/cards-types';
import { Characteristic, Flag, Type } from '@shared/cards-types';

export const isDebitCard = ({ type }: { type: Type }): boolean =>
    [Type.BANK_CARD, Type.VIRTUAL_DEBIT].includes(type);

export const isCreditCard = ({ type }: Card): boolean =>
    [Type.CREDIT, Type.VIRTUAL_CREDIT].includes(type);

export const isVirtualDebitCard = ({ type }: Card): boolean => type === Type.VIRTUAL_DEBIT;

export const isMainCard = ({ characteristic }: Card): boolean =>
    characteristic === Characteristic.MAIN;

export const isMainCreditCard = (card?: Card): boolean => {
    if (!card) {
        return false;
    }

    return isCreditCard(card) && isMainCard(card);
};

export const isDebitMobileCard = ({ type, flags = [] }: Card): boolean =>
    type === Type.BANK_CARD && flags?.includes(Flag.debitMobile);

export const isMicroChipCard = ({ type, flags = [] }: Card): boolean =>
    type === Type.BANK_CARD && flags?.includes(Flag.microChip);

export const isMicroStickerCard = ({ type, flags = [] }: Card): boolean =>
    type === Type.BANK_CARD && flags?.includes(Flag.microSticker);

export const isPrepaidCard = ({ type }: Card): boolean => type === Type.PREPAID;

export const isIndoorCard = ({ type }: Card): boolean => type === Type.INDOOR;

export const isStandaloneCard = ({ characteristic }: Card): boolean =>
    characteristic === Characteristic.AUTHORIZED_STANDALONE;

export const isStandaloneCreditCard = (card: Card): boolean =>
    isCreditCard(card) && isStandaloneCard(card);

const isAuthorizedCard = ({ characteristic }: Card) => characteristic === Characteristic.AUTHORIZED;
const isVirtualCreditCard = ({ type }: Card) => type === Type.VIRTUAL_CREDIT;
const isPhysicalCreditCard = ({ type }: Card) => type === Type.CREDIT;

export const isAuthorizedCreditCard = (card: Card) =>
    isAuthorizedCard(card) && isPhysicalCreditCard(card);

export const isAuthorizedVirtualCreditCard = (card: Card) =>
    isAuthorizedCard(card) && isVirtualCreditCard(card);
